import { t } from 'i18next';
import { Flex } from 'reflexbox';
import { ModalWindow } from '~/components';
import { ModalTitle } from '../Menu/styles';
import { useEffect, useState } from 'react';
import { CloseIcon } from '~/icons/CloseV2';
import {
  TabList,
  TabItem,
  Tab,
  TabLine,
  NewBadge,
} from './styles';

export default function ModalUserGuide(props: {
  handleCloseModal: () => void;
  menuToggle: boolean;
  initialTab?: 'pdf' | 'video';
}): JSX.Element {
  const { handleCloseModal, menuToggle, initialTab } = props;
  const [activeTab, setActiveTab] = useState<'pdf' | 'video'>(initialTab ?? 'pdf');

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleCloseModal();
      }
    };

    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [handleCloseModal]);

  return (
    <>
      <ModalWindow
        borderTop
        style={{
          marginLeft: menuToggle ? '200px' : '10px',
          marginRight: '30px',
          width: '90%',
          height: '90%',
          marginTop: '50px',
          marginBottom: '70px',
          overflow: 'hidden',
        }}
        onClickOutside={() => {
          handleCloseModal();
        }}
      >
        <Flex
          flexDirection="row"
          justifyContent="space-between"
          style={{
            marginBottom: '10px',
          }}
        >
          <ModalTitle>{t('guiaDoUsuario')}</ModalTitle>
          <CloseIcon onClick={() => { handleCloseModal(); }} />
        </Flex>

        <TabList>
          <TabItem>
            <Tab isActive={activeTab === 'pdf'} onClick={() => setActiveTab('pdf')}>
              {t('documentacao')}
            </Tab>
            <TabLine isActive={activeTab === 'pdf'} />
          </TabItem>
          <TabItem>
            <Tab isActive={activeTab === 'video'} onClick={() => setActiveTab('video')}>
              {t('mapaDeUnidade')}
              <NewBadge>{t('novo')}</NewBadge>
            </Tab>
            <TabLine isActive={activeTab === 'video'} />
          </TabItem>
        </TabList>

        <Flex
          style={{
            width: '100%',
            height: 'calc(100% - 90px)',
            overflowY: 'auto',
          }}
        >
          {activeTab === 'pdf' && (
            <iframe
              src="/userGuide.pdf"
              width="100%"
              height="100%"
              title={t('guiaDoUsuario')}
              frameBorder="0"
              allowFullScreen
            />
          )}
          {activeTab === 'video' && (
            <iframe
              src="https://www.youtube.com/embed/IFcQY7O4NX4"
              width="100%"
              height="100%"
              title={t('mapaDeUnidade')}
              style={{ border: 'none' }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </Flex>
      </ModalWindow>
    </>
  );
}
